"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBatteryFull = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M8.004 4h2.01c0-1.333.666-2 2-2 1.333 0 1.997.667 1.991 2H16c1.333 0 2 .667 2 2v14c0 1.333-.667 2-2 2H8c-1.333 0-2-.667-2-2V6.004C6 4.667 6.668 3.999 8.004 4z' }))); };
exports.default = SvgBatteryFull;
//# sourceMappingURL=BatteryFull.js.map